import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // Auto-authenticated as admin - NO LOGIN REQUIRED
  const [user, setUser] = useState({
    id: 'admin',
    username: 'admin',
    email: 'admin@tadaber.com',
    role: 'admin'
  });
  const [loading, setLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  // Auto-authenticate on mount
  const checkAuth = useCallback(async () => {
    // Always authenticated as admin
    setUser({
      id: 'admin',
      username: 'admin',
      email: 'admin@tadaber.com',
      role: 'admin'
    });
    setIsAuthenticated(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Login function - auto-succeeds (kept for compatibility)
  const login = async (username, password) => {
    setUser({
      id: 'admin',
      username: username || 'admin',
      email: 'admin@tadaber.com',
      role: 'admin'
    });
    setIsAuthenticated(true);
    return { success: true };
  };

  // Logout function - re-authenticates automatically
  const logout = async () => {
    // Just re-authenticate as admin
    setUser({
      id: 'admin',
      username: 'admin',
      email: 'admin@tadaber.com',
      role: 'admin'
    });
    setIsAuthenticated(true);
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
